import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import moment from "moment";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import { visuallyHidden } from "@mui/utils";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Drawer from "@mui/material/Drawer";
import ConfirmBox from "../../../UiComponents/ConfirmBox/ConfirmBox";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import {
  CloudOffIcon,
  SearchIcon,
  DeleteIcon,
  EditIcon,
  DownloadIcon,
} from "../../../Resources/Icons/icons";
import {
  GetPaidReceivedReport,
  DeletePolicyReportData,
  GetQuoteQueryRecords,
  GetCompany,
} from "../../../Service/_index";
import { DatePicker } from "antd";
import Dialog from "@mui/material/Dialog";
import { Transition } from "../../../UiComponents/Transition/Transition";
import { CSVLink } from "react-csv";
import MasterCommonTable from "../../../UiComponents/CommonTable/MasterCommonTable";
import { Divider, Stack, Badge } from "@mui/material";
import TabFilter from "../../Tabs/Tabs";
import CustomButton from "../../../UiComponents/CommonBUtton/ConfirmBox";
import FilterBox from "../../../UiComponents/FilterBox/FilterBox";
import FilterListIcon from "@mui/icons-material/FilterList";

const { RangePicker } = DatePicker;
const TodayDate = new Date();
// TodayDate .setHours(23, 0, 0, 0);
const Last7Days = new Date();
Last7Days.setDate(Last7Days.getDate() - 7);
const YesterDay = new Date();
YesterDay.setDate(YesterDay.getDate() - 1);
const Last30Days = new Date();
Last30Days.setDate(Last30Days.getDate() - 30);

const TodayDateByDaysjs = dayjs();
const FirstDateOfMonth = TodayDateByDaysjs.startOf("month");
// const [openLoader, setOpenLoader] = useState(false);
const FirstDateOfLastMonth = TodayDateByDaysjs.subtract(1, "month").startOf(
  "month"
);
const LastDateOfLastMonth = TodayDateByDaysjs.subtract(1, "month").endOf(
  "month"
);

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
  {
    id: "SNo",
    placeMent: true,
    disablePadding: false,
    label: "S.No",
  },
  {
    id: "userName",
    placeMent: true,
    disablePadding: false,
    label: "User Name",
  },
  {
    id: "vehicleName",
    placeMent: true,
    disablePadding: false,
    label: "Vehicle Name",
  },
  {
    id: "vehicleCount",
    placeMent: true,
    disablePadding: false,
    label: "Vehicle Count",
  },
];

const UserType = [
  { _id: "all", label: "All", value: "all" },
  { _id: true, label: "WebUser", value: true },
  { _id: false, label: "MobileUser", value: false },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells?.map((headCell) => (
          <TableCell
            className="TableHeader"
            key={headCell.id}
            align={headCell.placeMent ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ fontSize: "16px", fontWeight: 600 }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

const MotorReport = () => {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [selectedData, setSelectedData] = React.useState({});
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [report, setReport] = React.useState([]);
  const [userDetails, setUserDetails] = useState([]);
  const [selectedUser, setSelectedUser] = useState();
  const [selectedUserType, setSelectedUserType] = useState("all");
  const [selectedTds, setSelectedTds] = useState();
  const [isPaid, setIsPaid] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [openLoader, setOpenLoader] = useState(true);
  const [tableConfig, setTableConfig] = useState({
    isSearch: true,
    isApprove: true,
  });
  const [company, setCompany] = React.useState([]);
  const [openCompanyDrawer, setOpenCompanyDrawer] = React.useState(false);
  const [formType, setFormType] = useState("");
  const [openConfirmBox, setOpenConfirmBox] = React.useState(false);
  const [activeBoolean, setActiveBoolean] = useState();
  const [openDeleteConfirmBox, setOpenDeleteConfirmBox] = React.useState(false);
  const [originalData, setOriginalData] = useState([]);
  const [dateRange, setDateRange] = useState(null);
  const [showFilter, setShowFilter] = useState(false);

  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });
  console.log("all", report);

  const visibleRows = React.useMemo(
    () =>
      stableSort(filter.fn(report), getComparator(order, orderBy))?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage, filter, report]
  );

  const GetData = () => {
    GetCompany({ isAscending: false }).then((res) => {
      if (res?.data) {
        const updatedData = res.data.map((item) => ({
          ...item,
          status: item.isEnabled ? "Active" : "Inactive",
        }));
        setCompany(updatedData);
      }
    });
  };

  const FilteredData = company.filter((el) => {
    return `${el?.companyName},${el?.remarks},${el?.shortName}`.includes(
      searchText
    );
  });

  const HandleCustomDays = (startDate, endDate) => {
    setSelectedStartDate(dayjs(startDate.setHours(1, 0, 0, 0)));
    setSelectedEndDate(dayjs(endDate.setHours(23, 59, 59, 59)));
    setIsDatePickerOpen(false);
  };

  const onSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    if (searchTerm === "") {
      setReport(originalData);
    } else {
      const filteredData = originalData.filter((item) => {
        return Object.values(item).some(
          (value) =>
            value && value.toString().toLowerCase().includes(searchTerm)
        );
      });
      setReport(filteredData);
    }
    setPage(0);
  };

  const GetUserDetails = () => {
    setOpenLoader(true);
    GetQuoteQueryRecords({
      isWebUser: selectedUserType,
      startDate: selectedStartDate,
      endDate: selectedEndDate,
    }).then((res) => {
      if (res?.data) {
        console.log(res.data);
        let FilteredData = [];
        res.data.map((e, index) => {
          FilteredData.push({
            ...e,
            SNo: index + 1,
            label: e?.isWebUser ? e?.userName || "" : e?.motorUserName || "",
            value: e?._id || "",
          });
        });
        // .filter(Boolean);
        setReport(FilteredData);
        setUserDetails(FilteredData);
        setOriginalData(FilteredData);
        setPage(0);
      }
      setOpenLoader(false);
    });

    console.log({
      isWebUser: selectedUserType,
      startDate: selectedStartDate,
      endDate: selectedEndDate,
    });
  };
  React.useEffect(() => {
    GetUserDetails();
  }, []);

  React.useEffect(() => {
    GetUserDetails();
  }, [selectedUserType]);

  const header = [
    { label: "User Name", key: "userName" },
    { label: "Vehicle Name", key: "vehicleName" },
    { label: "Vehicle Count", key: "vehicleCount" },
  ];

  const csvFile = {
    filename: "Motor Report Data",
    headers: header,
    data: report,
  };

  // const handleFiltersClick = () => {
  //   setFiltersVisible((prev) => !prev);
  // };

  const filterBoxData = [
    {
      id: 1,
      label: "Filter Type ",
      data: UserType,
      setState: setSelectedUserType,
      value: selectedUserType,
      type: "input",
      variation: "single",
    },
    {
      id: 2,
      label: "Select User",
      data: userDetails,
      setState: setSelectedUser,
      value: selectedUser,
      type: "input",
      variation: "single",
    },
    {
      id: 3,
      label: "Select Date",
      setDate: setDateRange,
      type: "noDefaultDate",
    },
  ];

  const handleClearAllState = () => {
    setDateRange(null);
    setSelectedUser(null);
    setSelectedUserType("all");
    setSelectedStartDate(null);
    setSelectedEndDate(null);
  };

  const handleClearSingleFilter = (filterId) => {
    if (filterId === 1) {
      setSelectedUserType("all");
    } else if (filterId === 2) {
      setSelectedUser(null);
    } else if (filterId === 3) {
      setDateRange(null);
      setSelectedStartDate(null);
      setSelectedEndDate(null);
      
      // Trigger API call with cleared date filter
      setOpenLoader(true);
      GetQuoteQueryRecords({
        isWebUser: selectedUserType,
        startDate: null,
        endDate: null,
      }).then((res) => {
        if (res?.data) {
          let FilteredData = [];
          res.data.map((e, index) => {
            FilteredData.push({
              ...e,
              SNo: index + 1,
              label: e?.isWebUser ? e?.userName || "" : e?.motorUserName || "",
              value: e?._id || "",
            });
          });
          setReport(FilteredData);
          setUserDetails(FilteredData);
          setOriginalData(FilteredData);
          setPage(0);
        }
        setOpenLoader(false);
      });
    }
  };

  const handleSaveAllFilter = () => {
    GetUserDetails();
  };

  useEffect(() => {
    if (dateRange?.length > 0) {
      const newStartDate = dayjs(dateRange[0]);
      const newEndDate = dayjs(dateRange[1]);

      setSelectedStartDate(newStartDate);
      setSelectedEndDate(newEndDate);

      setOpenLoader(true);
      GetQuoteQueryRecords({
        isWebUser: selectedUserType,
        startDate: newStartDate,
        endDate: newEndDate,
      }).then((res) => {
        if (res?.data) {
          let FilteredData = [];
          res.data.map((e, index) => {
            FilteredData.push({
              ...e,
              SNo: index + 1,
              label: e?.isWebUser ? e?.userName || "" : e?.motorUserName || "",
              value: e?._id || "",
            });
          });
          setReport(FilteredData);
          setUserDetails(FilteredData);
          setOriginalData(FilteredData);
          setPage(0);
        }
        setOpenLoader(false);
      });
    }
  }, [dateRange]);

  const activeFiltersCount =
    (selectedUserType ? 1 : 0) +
    (selectedUser ? 1 : 0) +
    (dateRange?.[0] ? 1 : 0);

  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Box sx={{ position: "relative", zIndex: 1, mt: 0 }}>
          <Grid container className="Master_Card_Container">
            <Grid
              container
              alignItems="center"
              className="Master_Card_Sub_Container"
              spacing={2}
              sx={{ mb: 2 }}
            >
              <Grid item xs={12} sm={6} md={4}>
                <Typography className="Master_Card_Tittle">
                  Motor Report
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={8}
                className="d-flex"
                justifyContent={{
                  xs: "start",
                  sm: "flex-end",
                  md: "flex-end",
                }}
              >
                <Stack
                  direction={{ xs: "column", sm: "row", md: "row" }}
                  spacing={2}
                  mt={{ xs: 2, sm: 2, md: 0 }}
                >
                  <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
                    <Button
                      className="Master_Card_Filter_Button w-100"
                      sx={{ width: "102px", height: "40px", gap: "8px" }}
                      startIcon={
                        <Badge
                          badgeContent={activeFiltersCount}
                          //color="error"
                          sx={{
                            "& .MuiBadge-badge": {
                              right: 5,
                              top: 3,
                              width: "14px",
                              height: "14px",
                              minWidth: "14px",
                              borderRadius: "50%",
                              fontSize: "8.91px",
                              fontWeight: "600",
                              backgroundColor: "#E50000",
                              color: "#fff",
                              padding: 0,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            },
                          }}
                        >
                          <FilterListIcon sx={{ marginRight: "1.5px" }} />
                        </Badge>
                      }
                      onClick={() => setShowFilter(!showFilter)}
                    >
                      Filters
                    </Button>
                    <Button
                      className="Master_Card_Filter_Button w-100"
                      sx={{ width: "102px", height: "40px", gap: "8px" }}
                      fullWidth
                      startIcon={
                        <CloudDownloadOutlinedIcon
                          sx={{
                            color: "#344054",
                          }}
                        />
                      }
                    >
                      <CSVLink style={{ textDecoration: "none" }} {...csvFile}>
                        {/* //<p className="button-text" sx={{ color: "#070707ff" }}>Export</p> */}
                        <span style={{ color: "#000000" }}>Export</span>
                      </CSVLink>
                    </Button>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>

            {showFilter && (
              <Box
                sx={{
                  mb: 2,
                  overflow: "visible",
                  position: "relative",
                  zIndex: 1200,
                  minHeight: "60px",
                  width: "100%",
                }}
              >
                <FilterBox
                  filterData={filterBoxData}
                  type={"single"}
                  handleClearAllState={handleClearAllState}
                  handleSaveAllFilter={handleSaveAllFilter}
                  handleClearSingleFilter={handleClearSingleFilter}
                  horizontalLayout={true}
                  hideHeader={true}
                  hideInput={true}
                  alwaysOpen={true}
                />
              </Box>
            )}

            <Grid item xs={12}>
              <Divider
                sx={{
                  backgroundColor: "#EAECF0",
                  borderWidth: 1,
                }}
              />
            </Grid>
            <Grid
              container
              alignItems={"center"}
              justifyContent={"flex-end"}
              margin={1}
            >
              <Grid item xs={12} sm={4} md={3.1}>
                <Input
                  focused="false"
                  className="w-100 Master_Card_Input"
                  id="standard-adornment-password"
                  onChange={(e) => {
                    onSearch(e);
                    setPage(0);
                  }}
                  disableUnderline={true}
                  placeholder="Search in Access"
                  startAdornment={
                    <InputAdornment
                      position="start"
                      sx={{ marginRight: "0px" }}
                    >
                      <IconButton aria-label="toggle password visibility">
                        <SearchIcon
                          sx={{
                            fontSize: "20px",
                          }}
                        />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </Grid>
            </Grid>
            <MasterCommonTable
              tableConfig={tableConfig}
              data={report}
              columns={headCells}
              loading={openLoader}
            />
          </Grid>
        </Box>
      </Box>
    </>
  );
};
export default MotorReport;
